const url = 'igss-dependencies';
import { api } from 'api';
import Swal from 'sweetalert2';
import { push } from 'react-router-redux';
import { goBack } from 'react-router-redux';
import { initialize as initializeForm } from 'redux-form';
import { createActions, handleActions } from 'redux-actions';

const LOADER_IGSS_DEPENDENCY = 'LOADER_IGSS_DEPENDENCY';
const SET_DATA_IGSS_DEPENDENCY = 'SET_DATA_IGSS_DEPENDENCY';
const SET_PAGE_IGSS_DEPENDENCY = 'SET_PAGE_IGSS_DEPENDENCY';
const SET_UPDATE_DATA_IGSS_DEPENDENCY = 'SET_UPDATE_DATA_IGSS_DEPENDENCY';
const SET_BUSCADOR_IGSS_DEPENDENCY = 'SET_BUSCADOR_IGSS_DEPENDENCY';

const listar = (page = 1) =>  (dispatch, getStore) => {
    dispatch({type: LOADER_IGSS_DEPENDENCY, cargando: true});
    const store = getStore();
    const search = store.igss_dependencies.buscador;    
    let params = {page, search};
    
    api.get(`${url}`, params).catch((error) => {
        dispatch({type: LOADER_IGSS_DEPENDENCY, cargando: false});
        Swal(
            'Error',
            error.detail || 'Ha ocurrido un error, por favor vuelva a intentar.',
            'error'
        );
    }).then((data) => {        
        if(data){
            dispatch({type: SET_DATA_IGSS_DEPENDENCY, data});
            dispatch({type: SET_PAGE_IGSS_DEPENDENCY, page});
        }
        dispatch({type: LOADER_IGSS_DEPENDENCY, cargando: false});
    })
};

const detail = id => (dispatch, getState) =>{
    dispatch({type: LOADER_IGSS_DEPENDENCY, cargando: true});
    api.get(`${url}/${id}`).catch((error) => {
        dispatch({type: LOADER_IGSS_DEPENDENCY, cargando: false});
        if(error.statusCode === 404){
            dispatch(push('/users'))
        }
    }).then((data) => {
        dispatch({type: LOADER_IGSS_DEPENDENCY, cargando: false});
        if(data){
            console.log("detail: ", data);
            dispatch({type: SET_UPDATE_DATA_IGSS_DEPENDENCY, updateData: data});
            dispatch(initializeForm('igssDependencies', data))
        }
    })
}

const create = () => (dispatch, getStore) => {
    const formData = getStore().form.igssDependencies.values;
    dispatch({type: LOADER_IGSS_DEPENDENCY, cargando: true})
    
    api.post(`${url}`, formData).then((data) => {        
        dispatch({type: LOADER_IGSS_DEPENDENCY, cargando: false})
        Swal('Éxito', 'Se ha creado la dependencia del igss.', 'success')
        .then(() => {
            dispatch(push('/igss-dependencies'))
        })
    }).catch((error) => {
        dispatch({type: LOADER_IGSS_DEPENDENCY, cargando: false})
        Swal(
            'Error',
             error.detail || 'Ha ocurrido un error, por favor vuelva a intentar.',
            'error'
        );
    }).finally(() => {
        dispatch({type: LOADER_IGSS_DEPENDENCY, cargando: false})
    });
};

const update = () => (dispatch, getStore) => {
    const formData = _.cloneDeep(getStore().form.igssDependencies.values);
    console.log("form data in igss procedures ::: ", formData);
    dispatch({type: LOADER_IGSS_DEPENDENCY, cargando: true});
    api.put(`${url}/${formData.id}`, formData)
    .then((data) => {
        dispatch({type: LOADER_IGSS_DEPENDENCY, cargando: false});
        if(data){
            Swal(
                'Éxito',
                'Datos editados correctamente.',
                'success'
            ).then(() => {
                dispatch(push('/igss-dependencies'));
            })
        }
    })
    .catch((error) =>{
        dispatch({type: LOADER_IGSS_DEPENDENCY, cargando: false});
        Swal(
            'Error',
             error.detail || 'Ha ocurrido un error, verifique los datos.',
            'error'
        )
        if(error.statusCode === 404){
            dispatch(push('/igss-dependencies/create'));
        }
    })
}

const destroy = (id) => (dispatch, getStore) => {
    dispatch({type: LOADER_IGSS_DEPENDENCY, cargando: true});
    api.eliminar(`${url}/${id}`).catch((error) => {
        dispatch({type: LOADER_IGSS_DEPENDENCY, cargando: false});
        Swal('Error', 'No se ha logrado borrar el registro.', 'error')
            .then(() => {
                dispatch(listar(1));
            })
    }).then((data) => {
        dispatch({type: LOADER_IGSS_DEPENDENCY, cargando: false});
        Swal('Éxito', 'Se ha eliminado correctamente.', 'success')
            .then(() => {
                dispatch(listar(1));
            })
    })
}

const search = (search) => (dispatch) => {
    dispatch({type: SET_BUSCADOR_IGSS_DEPENDENCY, buscador: search});
    dispatch(listar(1));
};

export const actions = {
    listar,
    create,
    update,
    detail,
    destroy,
    search    
};

export const reducer = {
    [LOADER_IGSS_DEPENDENCY]: (state, { cargando }) => {
        return {...state, cargando }
    },
    [SET_DATA_IGSS_DEPENDENCY]: (state, { data }) => {
        return {...state, data }
    },
    [SET_PAGE_IGSS_DEPENDENCY]: (state, { page }) => {
        return {...state, page }
    },
    [SET_UPDATE_DATA_IGSS_DEPENDENCY]: (state, { updateData }) => {
        return {...state, updateData }
    },
    [SET_BUSCADOR_IGSS_DEPENDENCY]: (state, { buscador }) => {
        return {...state, buscador }
    }    
};

export const initialState = {
    cargando: false,
    page: 1,
    data: {
        count: 0,
        next: null,
        previous: null,
        results: [],
    },
    buscador: '',    
    updateData: {},
};

export default handleActions(reducer, initialState)